module.exports = __webpack_public_path__ + "img/DeQuervian.d20811cb.svg";